import React, { useState } from "react";
import { RegistrationType } from "../model/signup-types";
import regiType01 from "@/shared/assets/img/regi_type_01.png";
import regiType02 from "@/shared/assets/img/regi_type_02.png";
import regiType03 from "@/shared/assets/img/regi_type_03.png";

interface SignupRegistrationTypeProps {
  onNext: (type: RegistrationType) => void;
}

/**
 * 회원가입 타입 선택 컴포넌트
 * 사용자가 가입 유형(기업/유치원/프랜차이즈)을 선택할 수 있습니다
 */
export function SignupRegistrationType({
  onNext,
}: SignupRegistrationTypeProps) {
  const [selectedType, setSelectedType] = useState<RegistrationType | null>(
    null
  );

  const types: Array<{
    id: RegistrationType;
    label: string;
    image: string;
  }> = [
    {
      id: "individual",
      label: "개인",
      image: regiType01,
    },
    {
      id: "kindergarten",
      label: "유치원",
      image: regiType02,
    },
    {
      id: "franchise",
      label: "프랜차이즈",
      image: regiType03,
    },
  ];

  const handleTypeSelect = (typeId: RegistrationType) => {
    setSelectedType(typeId);
  };

  const handleNext = () => {
    if (selectedType) {
      onNext(selectedType);
    }
  };

  return (
    <div className="w-full max-w-4xl">
      {/* 제목 */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">회원가입</h1>
        <p className="text-gray-600 text-lg">
          회원가입할 최적 선택을 하는 것을 도와드립니다.
        </p>
      </div>

      {/* 회원가입 타입 선택 카드 */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-10">
        {types.map((type) => (
          <button
            key={type.id}
            onClick={() => handleTypeSelect(type.id)}
            className={`p-8 rounded-3xl transition-all duration-300 cursor-pointer transform hover:scale-105 ${
              selectedType === type.id
                ? "bg-[#FFF1EB] border-2 border-[#FFB898]"
                : "bg-gray-100 border-2 border-transparent hover:border-gray-300"
            }`}
          >
            {/* 이미지 영역 */}
            <div className="flex justify-center mb-6">
              <img
                src={type.image}
                alt={type.label}
                className="w-24 h-24 object-contain"
              />
            </div>
            {/* 라벨 */}
            <p className="text-center text-xl font-semibold text-gray-800">
              {type.label}
            </p>
          </button>
        ))}
      </div>

      {/* 다음 버튼 */}
      <div className="flex justify-center my-10">
        <button
          onClick={handleNext}
          disabled={!selectedType}
          className={`px-12 py-3 rounded-full font-semibold text-white text-lg transition-all duration-300 ${
            selectedType
              ? "bg-[#FF7131] hover:bg-orange-600 cursor-pointer"
              : "bg-gray-300 cursor-not-allowed opacity-50"
          }`}
        >
          다음
        </button>
      </div>
    </div>
  );
}
